<template>
  <registration-form class="registration-form" />
</template>

<script>
export default {
  name: "App",
};
</script>